<template>
  <div>
    <v-app-bar class="modern-navbar" fixed app>
      <v-app-bar-title class="navbar-title">
        Team Practice Plan
      </v-app-bar-title>

      <v-spacer></v-spacer>

      <!-- Desktop Navigation Links -->
      <div class="navbar-links desktop-nav" v-if="!isSharedView">
        <v-btn
            :to="{ name: 'home' }"
            variant="text"
            class="navbar-btn"
            :class="{ 'active': $route.name === 'home' }"
        >
          <v-icon class="me-2">mdi-home</v-icon>
          Home
        </v-btn>

        <v-btn
            :to="{ name: 'planedit', params: { id: 'new' } }"
            variant="text"
            class="navbar-btn"
            :class="{ 'active': $route.name === 'planedit' && $route.params.id === 'new' }"
        >
          <v-icon class="me-2">mdi-plus</v-icon>
          New Practice Plan
        </v-btn>

        <v-btn
            :to="{ name: 'drilllibrary' }"
            variant="text"
            class="navbar-btn"
            :class="{ 'active': $route.name === 'drilllibrary' }"
        >
          <v-icon class="me-2">mdi-library</v-icon>
          Drill Library
        </v-btn>

        <!-- <v-btn 
          :to="{ name: 'subscription' }" 
          variant="text" 
          class="navbar-btn"
          :class="{ 'active': $route.name === 'subscription' }"
        >
          <v-icon class="me-2">mdi-credit-card</v-icon>
          Subscription
        </v-btn> -->

        <!-- Teams Dropdown -->
        <v-menu v-if="user.teams && user.teams.length > 0">
          <template v-slot:activator="{ props }">
            <v-btn
                v-bind="props"
                variant="text"
                class="navbar-btn"
                :class="{ 'active': $route.name === 'teamedit' }"
            >
              <v-icon class="me-2">mdi-account-group</v-icon>
              Teams
              <v-icon class="ms-1">mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-list class="teams-menu">
            <v-list-item
                v-for="team in user.teams"
                :key="team.id"
                :to="{ name: 'teamedit', params: { id: team.id } }"
                class="team-menu-item"
            >
              <v-list-item-title>{{ team.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <!-- Mobile Menu Button -->
      <v-btn
          v-if="!isSharedView"
          class="mobile-menu-btn"
          variant="text"
          icon
          @click="toggleMobileMenu"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>

      <!-- User Info -->
      <div class="user-info" v-if="!isSharedView && user.name">
        <v-avatar size="32" class="me-2">
          <v-icon>mdi-account</v-icon>
        </v-avatar>
        <span class="user-name">{{ user.name }}</span>
      </div>
    </v-app-bar>

    <!-- Mobile Navigation Drawer -->
    <v-navigation-drawer
        v-if="!isSharedView"
        v-model="mobileMenuOpen"
        temporary
        location="right"
        class="mobile-nav-drawer"
        width="280"
    >
      <v-list class="mobile-nav-list">
        <v-list-item
            :to="{ name: 'home' }"
            class="mobile-nav-item"
            :class="{ 'active': $route.name === 'home' }"
            @click="closeMobileMenu"
        >
          <template v-slot:prepend>
            <v-icon>mdi-home</v-icon>
          </template>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>

        <v-list-item
            :to="{ name: 'planedit', params: { id: 'new' } }"
            class="mobile-nav-item"
            :class="{ 'active': $route.name === 'planedit' && $route.params.id === 'new' }"
            @click="closeMobileMenu"
        >
          <template v-slot:prepend>
            <v-icon>mdi-plus</v-icon>
          </template>
          <v-list-item-title>New Practice Plan</v-list-item-title>
        </v-list-item>

        <v-list-item
            :to="{ name: 'drilllibrary' }"
            class="mobile-nav-item"
            :class="{ 'active': $route.name === 'drilllibrary' }"
            @click="closeMobileMenu"
        >
          <template v-slot:prepend>
            <v-icon>mdi-library</v-icon>
          </template>
          <v-list-item-title>Drill Library</v-list-item-title>
        </v-list-item>

        <!--        <v-list-item -->
        <!--          :to="{ name: 'subscription' }" -->
        <!--          class="mobile-nav-item"-->
        <!--          :class="{ 'active': $route.name === 'subscription' }"-->
        <!--          @click="closeMobileMenu"-->
        <!--        >-->
        <!--          <template v-slot:prepend>-->
        <!--            <v-icon>mdi-credit-card</v-icon>-->
        <!--          </template>-->
        <!--          <v-list-item-title>Subscription</v-list-item-title>-->
        <!--        </v-list-item>-->

        <!-- Teams Section in Mobile -->
        <v-list-group v-if="user.teams && user.teams.length > 0">
          <template v-slot:activator="{ props }">
            <v-list-item
                v-bind="props"
                class="mobile-nav-item"
            >
              <template v-slot:prepend>
                <v-icon>mdi-account-group</v-icon>
              </template>
              <v-list-item-title>Teams</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
              v-for="team in user.teams"
              :key="team.id"
              :to="{ name: 'teamedit', params: { id: team.id } }"
              class="mobile-nav-item team-item"
              @click="closeMobileMenu"
          >
            <v-list-item-title>{{ team.name }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {ref} from 'vue';
import {currentUserStore} from '../stores/currentUserStore'

export default {
  name: 'PageHeader',
  data() {
    return {
      user: ref({}),
      isSharedView: false,
      mobileMenuOpen: false,
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    }
  },
  mounted() {
    let self = this;
    this.user = currentUserStore().currentUser;

    currentUserStore().$subscribe(() => {
      self.user = currentUserStore().currentUser;
    });
  },
  created() {
    this.$watch(
        () => {
          this.isSharedView = this.$route.name === "sharedview";
        },
        () => {
          this.isSharedView = this.$route.name === "sharedview";
        },
        {immediate: true}
    )
  },

}
</script>

<style scoped>
/* Modern navbar styling */
.modern-navbar {
  background: linear-gradient(270deg, var(--brand-ink) 0%, var(--brand-accent) 100%) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: var(--shadow-sm) !important;
}

.navbar-title {
  font-weight: 700 !important;
  color: var(--on-brand) !important;
  font-size: 1.3rem !important;
}

.navbar-links {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.navbar-btn {
  border-radius: var(--radius-none) !important;
  text-transform: none !important;
  font-weight: 500 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  transition: all 0.2s ease !important;
}

.navbar-btn:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: var(--on-brand) !important;
}

.navbar-btn.active {
  background-color: rgba(255, 255, 255, 0.2) !important;
  color: var(--on-brand) !important;
  font-weight: 600 !important;
}

.user-info {
  display: flex;
  align-items: center;
  margin-left: var(--space-4);
  padding-left: var(--space-4);
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

.user-name {
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
}

.teams-menu {
  border-radius: var(--radius-none) !important;
  box-shadow: var(--shadow-md) !important;
  border: 1px solid var(--border-subtle) !important;
}

.team-menu-item {
  border-radius: var(--radius-none) !important;
  transition: all 0.2s ease !important;
}

.team-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
}

/* Mobile Menu Button */
.mobile-menu-btn {
  display: none !important;
  color: white !important;
}

/* Mobile Navigation Drawer */
.mobile-nav-drawer {
  background: linear-gradient(180deg, var(--brand-ink) 0%, var(--brand-accent) 100%) !important;
}

.mobile-nav-list {
  background: transparent !important;
  padding-top: var(--space-5) !important;
}

.mobile-nav-item {
  color: rgba(255, 255, 255, 0.9) !important;
  margin-bottom: var(--space-1) !important;
  border-radius: var(--radius-sm) !important;
  margin-left: var(--space-2) !important;
  margin-right: var(--space-2) !important;
}

.mobile-nav-item:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.mobile-nav-item.active {
  background-color: rgba(255, 255, 255, 0.2) !important;
  font-weight: 600 !important;
}

.mobile-nav-item.team-item {
  margin-left: 24px !important;
  font-size: 0.9rem !important;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .desktop-nav {
    display: none !important;
  }

  .mobile-menu-btn {
    display: flex !important;
  }

  .user-info {
    margin-left: 8px;
    padding-left: 8px;
  }

  .user-name {
    display: none;
  }
}

@media (max-width: 480px) {
  .navbar-title {
    font-size: 1.1rem !important;
  }

  .user-info .v-avatar {
    width: 28px !important;
    height: 28px !important;
  }
}

/* Legacy styles for compatibility */
header {
  margin-bottom: 75px;
}

.team-item {
  margin-left: 10px;
  list-style: none;
}
</style>
    